import api from '@pray/shared/utils/api';

export async function removeOrganizationMember(organizationId: string, userId: string) {
  const url = `/web/studio/organizations/${organizationId}/members/${userId}`;

  await api.executeDeleteRequest(url);

  return { success: true };
}
